(function () {
  function closest(root, selector) {
    return root && root.closest ? root.closest(selector) : null;
  }

  function initReviewCarousel(carousel) {
    var track = carousel.querySelector("[data-ghos-reviews-track]");
    var prev = carousel.querySelector("[data-ghos-reviews-prev]");
    var next = carousel.querySelector("[data-ghos-reviews-next]");
    if (!track || !prev || !next) return;

    function getStep() {
      var cards = Array.prototype.slice.call(track.querySelectorAll(".ghos-review-card"));
      if (!cards.length) return 0;

      var styles = window.getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || "0") || 0;
      var cardWidth = cards[0].getBoundingClientRect().width;
      var visibleCount = Math.max(1, Math.round((track.clientWidth + gap) / (cardWidth + gap)));
      return visibleCount * (cardWidth + gap);
    }

    function updateState() {
      var maxScroll = Math.max(0, track.scrollWidth - track.clientWidth - 2);
      var isStatic = maxScroll <= 0;
      carousel.classList.toggle("is-static", isStatic);
      prev.disabled = isStatic || track.scrollLeft <= 2;
      next.disabled = isStatic || track.scrollLeft >= maxScroll;
    }

    prev.onclick = function () {
      track.scrollBy({ left: -getStep(), behavior: "smooth" });
    };

    next.onclick = function () {
      track.scrollBy({ left: getStep(), behavior: "smooth" });
    };

    track.addEventListener("scroll", updateState, { passive: true });
    window.addEventListener("resize", updateState);
    updateState();
    setTimeout(updateState, 250);
  }

  function initReviewCarousels(root) {
    (root || document).querySelectorAll("[data-ghos-reviews-carousel]").forEach(initReviewCarousel);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initReviewCarousels(document);
    });
  } else {
    initReviewCarousels(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initReviewCarousels(event.target);
  });

  document.addEventListener("click", function (event) {
    var trigger = closest(event.target, "[data-ghos-search-toggle]");
    var close = closest(event.target, "[data-ghos-search-close]");
    var popover = document.querySelector("[data-ghos-search-popover]");

    if (!popover) return;

    if (trigger) {
      var isOpen = popover.classList.toggle("is-open");
      trigger.setAttribute("aria-expanded", isOpen ? "true" : "false");
      if (isOpen) {
        var input = popover.querySelector("input[name='q']");
        if (input) input.focus();
      }
      return;
    }

    if (close) {
      popover.classList.remove("is-open");
      var button = document.querySelector("[data-ghos-search-toggle]");
      if (button) button.setAttribute("aria-expanded", "false");
      return;
    }

    if (!popover.contains(event.target) && !trigger) {
      popover.classList.remove("is-open");
      var toggle = document.querySelector("[data-ghos-search-toggle]");
      if (toggle) toggle.setAttribute("aria-expanded", "false");
    }
  });

  document.addEventListener("input", function (event) {
    if (!event.target.matches("[data-ghos-search-input]")) return;

    var input = event.target;
    var popover = closest(input, "[data-ghos-search-popover]");
    var results = popover ? popover.querySelector("[data-ghos-search-results]") : null;
    var query = input.value.trim();

    if (!popover || !results) return;

    clearTimeout(input.ghosSearchTimer);
    results.classList.remove("is-ready");

    if (!query) {
      popover.classList.remove("has-query");
      results.innerHTML = "";
      return;
    }

    popover.classList.add("has-query");
    input.ghosSearchTimer = setTimeout(function () {
      results.innerHTML =
        '<div class="ghos-search-empty">Press Enter to search for "' +
        query.replace(/[&<>"']/g, function (match) {
          return {
            "&": "&amp;",
            "<": "&lt;",
            ">": "&gt;",
            '"': "&quot;",
            "'": "&#039;"
          }[match];
        }) +
        '".</div>';
      results.classList.add("is-ready");
    }, 300);
  });

  document.addEventListener("click", function (event) {
    var thumb = closest(event.target, "[data-ghos-gallery-thumb]");
    if (!thumb) return;

    var gallery = closest(thumb, "[data-ghos-gallery]");
    var main = gallery ? gallery.querySelector("[data-ghos-gallery-main]") : null;
    var image = thumb.querySelector("img");

    if (!gallery || !main || !image) return;

    main.src = image.dataset.fullSrc || image.src;
    main.alt = image.alt;

    gallery.querySelectorAll("[data-ghos-gallery-thumb]").forEach(function (button) {
      button.setAttribute("aria-current", button === thumb ? "true" : "false");
    });
  });

  document.addEventListener("click", function (event) {
    var button = closest(event.target, "[data-ghos-quantity]");
    if (!button) return;

    var input = document.querySelector(button.dataset.ghosQuantity);
    if (!input) return;

    var delta = button.dataset.ghosQuantityAction === "minus" ? -1 : 1;
    var current = Number(input.value || 0);
    var min = Number(input.min || 0);
    input.value = Math.max(min, current + delta);
    input.dispatchEvent(new Event("change", { bubbles: true }));
  });
})();
